import http from '@/utils/request'
export default {
    messageRuleList: {
        url: 'mc/rule/page',
        name: '往来规则列表',
        post: async function(data) {
          return await http.post(this.url, data)
        }
    },
    getMcType: { // 获取往来类型
      url: 'mc/rule/mcType',
      name: '获取往来类型',
      get: async function(params) {
        return await http.get(this.url + '/' + params.id)
      }
    },
    getTriggerType: { // 获取触发方式
      url: 'mc/rule/mcTrigger',
      name: '获取触发方式',
      get: async function(params) {
        return await http.get(this.url + '/' + params.mcTypeId)
      }
    },
    getMcTriggerField: { // 获取筛选条件
      url: 'mc/rule/mcTriggerField',
      name: '获取筛选条件',
      get: async function(params) {
        return await http.get(this.url + '/' + params.triggerId)
      }
    },
    getMcOperator: { // 获取运算符
      url: 'mc/rule/mcOperator',
      name: '获取筛选条件',
      get: async function(params) {
        return await http.get(this.url + '/' + params.triggerFieldId)
      }
    },
    getMcRoles: {
        url: 'mc/message/template/roles',
        name: '获取收发件人角色',
        post: async function(data) {
          return await http.post(this.url, data)
        }
    },
    getMcAttachments: {
        url: 'mc/message/template/attachment',
        name: '获取附件选项',
        post: async function(data) {
          return await http.post(this.url, data)
        }
    },
    getDefaultField: {
        url: 'mc/message/template/field',
        name: '往来规则查询字段',
        post: async function(data) {
          return await http.post(this.url, data)
        }
    },
    saveRule: {
        url: 'mc/rule/save',
        name: '往来规则保存',
        post: async function(data) {
          return await http.post(this.url, data)
        }
    },
    ruleDetail: { // 获取往来类型
      url: 'mc/rule/detail',
      name: '获取往来类型',
      get: async function(params) {
        return await http.get(this.url + '/' + params.id)
      }
    },
    ruleStatus: {
        url: 'mc/rule/batch/changes/status',
        name: '往来规则启用禁用',
        post: async function(data) {
          return await http.post(this.url, data)
        }
    },
    getDefaultMessage: {
      url: 'mc/message/template/message',
      name: '往来规则查询模板默认配置消息',
      post: async function(data) {
        return await http.post(this.url, data)
      }
    },
    getAccount: { // 获取账号
      url: 'mc/channel/email/account/get',
      name: '获取账号',
      get: async function(params) {
        return await http.get(this.url, params)
      }
    },
    getServiceType: { // 获取服务类型
      url: 'mc/rule/serviceType',
      name: '获取服务类型',
      get: async function() {
        return await http.get(this.url)
      }
    },
    sendEmail: {
      url: 'mc/channel/email/send',
      name: '发送/保存邮件',
      post: async function(data) {
        return await http.post(this.url, data)
      }
    },
    updateOutbox: {
      url: 'mc/channel/email/update/outbox',
      name: '更新发件箱',
      post: async function(data) {
        return await http.post(this.url, data)
      }
    },
    getOutBoxEmailDetail: { // 查询发件箱详情
      url: 'mc/channel/email/getOutBoxEmailDetail',
      name: '查询发件箱详情',
      get: async function(params) {
        return await http.get(this.url, params)
      }
    },
    getInternalMessageDetail: { // 查询站内信详情
      url: 'mc/channel/internalMessage/detail',
      name: '查询站内信详情',
      get: async function(params) {
        return await http.get(this.url, params)
      }
    },
    getInternalOutMessageDetail: { // 查询站内信-已发送详情
      url: 'mc/channel/internalMessage/outbox/detail',
      name: '查询站内信-已发送详情',
      get: async function(params) {
        return await http.get(this.url, params)
      }
    },
    getInBoxEmailDetail: { // 查询收件箱详情
      url: 'mc/channel/email/getInBoxEmailDetail',
      name: '查询站内信-已发送详情',
      get: async function(params) {
        return await http.get(this.url, params)
      }
    },
    updateInternalMessage: {
      url: 'mc/channel/internalMessage/update',
      name: '更新站内信',
      post: async function(data) {
        return await http.post(this.url, data)
      }
    },
    updateInternalOutMessage: {
      url: 'mc/channel/internalMessage/outbox/update',
      name: '更新站内信-已发送',
      post: async function(data) {
        return await http.post(this.url, data)
      }
    },
    updateInbox: {
      url: 'mc/channel/email/update/inbox',
      name: '更新收件箱',
      post: async function(data) {
        return await http.post(this.url, data)
      }
    },
    getAvailableMembers: { // 查询可选的成员清单
      url: 'patent/patentOfficialBill/getInfo',
      name: '详情',
      get: async function(params) {
        return await http.get(this.url, params)
      }
    },
    emailList: {
        url: 'mc/channel/email/inbox/page',
        name: '收件箱',
        post: async function(data) {
          return await http.post(this.url, data)
        }
    },
    starList: {
        url: 'mc/channel/email/inbox/page',
        name: '星标邮件',
        post: async function(data) {
          return await http.post(this.url, data)
        }
    },
    outboxList: {
        url: 'mc/channel/email/outbox/page',
        name: '已发送',
        post: async function(data) {
          return await http.post(this.url, data)
        }
    },
    draftsList: {
        url: 'mc/channel/email/outbox/page',
        name: '草稿箱',
        post: async function(data) {
          return await http.post(this.url, data)
        }
    },
    internalInboxList: {
        url: 'mc/channel/internalMessage/page',
        name: '站内信收件箱',
        post: async function(data) {
          return await http.post(this.url, data)
        }
    },
    internalOutboxList: {
        url: 'mc/channel/internalMessage/outbox/page',
        name: '站内信已发送',
        post: async function(data) {
          return await http.post(this.url, data)
        }
    },
    getEmailConfig: { // 获取邮箱配置详情
      url: 'mc/channel/email/getEmailConfig',
      name: '获取邮箱配置详情',
      get: async function(params) {
        return await http.get(this.url, params)
      }
    },
    insertOrUpdateEmailConfig: {
      url: 'mc/channel/email/insertOrUpdateEmailConfig',
      name: '添加或者删除邮箱配置',
      post: async function(data) {
        return await http.post(this.url, data)
      }
    },
    shareEmailPage: {
      url: 'mc/channel/email/shareEmailConfig/page',
      name: '公有邮箱配置列表',
      post: async function(data) {
        return await http.post(this.url, data)
      }
    },
    insertOrUpdateShareEmailConfig: {
      url: 'mc/channel/email/insertOrUpdateShareEmailConfig',
      name: '公有邮箱配置列表',
      post: async function(data) {
        return await http.post(this.url, data)
      }
    },
    detailByDataTypeForPreset: {
      url: 'mc/message/sign/detail',
      name: '签名配置',
      get: async function(params) {
        return await http.get(this.url, params)
      }
    },
    messageTemplateSubmit: {
      url: 'mc/message/sign/save',
      name: '签名配置',
      post: async function(data) {
        return await http.post(this.url, data)
      }
    },
    syncEmail: {
      url: 'mc/channel/email/syncEmail',
      name: '立即同步邮箱',
      get: async function(params) {
        return await http.get(this.url, params)
      }
    },
    getUnReadMessage: {
      url: 'mc/channel/message/unReadMessage',
      name: '获取已读未读消息列表',
      get: async function(params) {
        return await http.get(this.url, params)
      }
    },
}